let presentPage = 1;
let isLoadPageNext  = true;
const anchor = document.getElementById('anchor');
const heightScreen = screen.height;
var lastScrollTop = 0;
let itemProduct = 1;
let isPage = 1;
let indexItem = 1;

addEventListener("scroll", function(){
 if(screen.width < 990) {
    var st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > lastScrollTop) {
      let itemFirst = document.querySelector(`li[data-index="${itemProduct}-page-${isPage}"]`);
      if(itemFirst) {
        let rect = itemFirst.getBoundingClientRect();
        if(rect.top < -100) {
          itemFirst.classList.add('tw-invisible')
          itemFirst.classList.add('item-hidden')
          indexItem ++;
          itemProduct++;
          if(itemProduct == 37) {
            itemProduct = 1;
            isPage++;
          }
        }
      }
    } else if (st < lastScrollTop) {
      let itemFirst = document.querySelectorAll('.item-hidden');
      if(itemFirst) {
        itemFirst.forEach(item=> {
          item.classList.remove('tw-invisible')
          item.classList.remove('item-hidden')
        })
        indexItem--;
        itemProduct--;
        if(itemProduct == 0) {
          if(isPage > 1) {
            isPage--;
            itemProduct = 36;
          } else {
            itemProduct = 1;
          }
        }
      } else {
        indexItem--;
      }

    }
    lastScrollTop = st <= 0 ? 0 : st;
  }
}, false);

addEventListener('scroll', async function () {
  if (isLoadPageNext && isInViewport(anchor, Number(heightScreen * 100 / 50)) && presentPage < totalPage && screen.width < 992 && isLoadAgain == false) {
    isLoadPageNext = false
    await loadFirstProduct(Number(totalPage), true);
    isLoadPageNext = true;
  }
  if((presentPage +1) >= totalPage && !anchor.classList.contains('tw-hidden') ) {
    anchor.classList.add('tw-hidden')
  }
});
function getFetchParam(){
  var sectionId = document.querySelector(".section-id").innerText;
  return "&section_id=" + sectionId;
}

function getFilterParams(){
  let currParam = window.location.search.replace("?", "");
  let currParamArr = currParam.split("&");
  let returnParam = "";
  let isLoadedPages = false;
  currParamArr.forEach(el => {
    if(el.includes("filter")){
      returnParam += "&" + el;
    }else if(el.includes("pages")){
      isLoadedPages = true;
    }
  });

  if(isLoadedPages == false){
    presentPage = 1;
  }

  return returnParam;
}

async function loadFirstProduct(totalPage, isUpdateUrl) {
  let load_more_btn = document.getElementsByClassName('load-more_btn')[0];
  let load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];
  let load_more_spinner_wrapper = document.getElementsByClassName('load-more_spinner_wrapper')[0];
  const url = new URL(location);

  if (presentPage <= totalPage) {
    if (load_more_btn) load_more_btn.style.display = 'none';
    if (load_more_spinner) load_more_spinner.style.display = 'block';
    if (load_more_spinner_wrapper) load_more_spinner_wrapper.style.display = 'block';

    let filterParam = getFilterParams();
    presentPage++;
    if (isUpdateUrl) {
      if (presentPage >= totalPage) presentPage = totalPage;
      url.searchParams.set("pages", presentPage);
      history.pushState({}, "", url);
    }

    let nextUrl = window.location.href;
    nextUrl = nextUrl + '?page=' + presentPage;
    if (nextUrl.slice("?").length > 1) {
      nextUrl = nextUrl.replace('?', '?page=' + presentPage + '&');
    }
    var sectionIdParam = getFetchParam();
    nextUrl = nextUrl + sectionIdParam;
    nextUrl = nextUrl + filterParam;

    let elementAddItem = document.getElementById('product-grid');
    let nextPage = await getProductNextPage(nextUrl);
    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
    const productGrid = nextPageDoc.getElementById('product-grid');

    if (productGrid) {
      const new_products = productGrid.getElementsByClassName('grid__item');
      for (let i = 0; i < new_products.length; i++) {
        let single_product = new_products[i].cloneNode(true);
        elementAddItem.appendChild(single_product);
      }
    }

    var scriptsInsideFetch = nextPageDoc.querySelectorAll("script[data-script='render-color']");
    scriptsInsideFetch.forEach(script => {
      try {
        eval(script.innerHTML);
      } catch (e) {
        console.warn('Error ejecutando script de render-color:', e);
      }
    });

    renderSwatchProduct();
    renderSizeGuild();
    renderSizeProduct();
    addEventClosePopup();

    if (load_more_btn) load_more_btn.style.display = 'block';
    if (load_more_spinner) load_more_spinner.style.display = 'none';
    if (load_more_spinner_wrapper) load_more_spinner_wrapper.style.display = 'none';

    if (Number(presentPage) >= Number(totalPage)) {
      document.getElementById('anchor')?.remove();
    }
  } else {
    document.getElementById('anchor')?.remove();
  }

  isLoadPageNext = true;
}
async function loadMoreProducts(el,totalPage, pageText="Página", ofText="de", isUpdateUrl = true) {
  await loadFirstProduct(totalPage, isUpdateUrl);
  if(presentPage == totalPage) {
    openItemHidden();
  }

  let paddingBottom = el.closest('.paginate__bottom');
  if(paddingBottom) {
    let progressText = paddingBottom.querySelector('.progress-text');
    let paginationProgress = paddingBottom.querySelector('.pagination__progress-bar').querySelector('.pagination__progress-bar-inner');
    progressText.textContent = pageText + ' '+ presentPage + ' ' + ofText + ' ' + totalPage;
    paginationProgress.style.width =  (Number(presentPage) / Number(totalPage) * 100) + '%';
  }
  if(Number(presentPage) == Number(totalPage)) {
    document.getElementsByClassName('load-more_btn')[0].style.display = 'none';
  }
}

function openItemHidden() {
  document.querySelectorAll('.custom-grid-item-hidden').forEach(item => {
    item.classList.remove('tw-hidden');
    item.classList.remove('custom-grid-item-hidden');
  })
}